import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const inserirUsuario = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await api.post('/usuarios/inserir', params, { headers });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarUsuario = async (id: any, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/usuarios/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar Usuario';
    throw new Error(errorMessage);
  }
};

export const obterUsuario = async (id: number) => {
  try {
    const response = await api.get(`/usuarios/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter Usuario';
    throw new Error(errorMessage);
  }
};

export const listarUsuarios = async (page: number, size: number) => {
  try {
    const response = await api.get(`/usuarios/listar?pagina=${page}&tamanhoPagina=${size}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar Usuarios';
    throw new Error(errorMessage);
  }
};

export const listarTiposPerfisAtivos = async () => {
  try {
    const response = await api.get('/perfis/ativos');
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const autenticarCpf = async (cpf: string) => {
  try {
    const response = await api.get(`usuarios/autenticaCpf?cpf=${cpf}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao autenticar cpf';
    throw new Error(errorMessage);
  }
};

export const deletarRelacionamentoCategoria = async (seqCategoria: number, seqUsuario: number ) => {
  try {
    const response = await api.delete(`/usuarios/deletarRelacionamento?seqCategoria=${seqCategoria}&seqUsuario=${seqUsuario}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao deletar relacionamento de categoria';
    throw new Error(errorMessage);
  }
};

export const inserirFotoPerfilNoCdn = async (params: FormData) => {
  try {
    const response = await api.post('/files/upload', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarFotoPerfilNoCdn = async (params: FormData) => {
  try {
    const response = await api.put('/files/update', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};